import { Box, Button, CircularProgress } from "@mui/material";
import BinIcon from "../../../../assets/icons/delete_referral.svg";

interface SelectionCounts {
  deletableCount: number;
  hideableCount: number;
}

interface BulkDeleteButtonProps {
  selectedCount: number;
  selectionCounts: SelectionCounts;
  isBulkDeleting: boolean;
  isExistingBookingLink: boolean;
  onDeleteClick: () => void;
}

const BulkDeleteButton = ({
  selectedCount,
  selectionCounts,
  isBulkDeleting,
  isExistingBookingLink,
  onDeleteClick,
}: BulkDeleteButtonProps) => {
  if (isExistingBookingLink) {
    return null;
  }

  const { deletableCount, hideableCount } = selectionCounts;

  // Determine button text based on selection types
  const getButtonText = () => {
    if (selectedCount === 0) {
      return "Delete Multiple Availabilities";
    }

    if (deletableCount > 0 && hideableCount > 0) {
      return "Delete/Hide Multiple Availabilities";
    } else if (hideableCount > 0) {
      return "Hide Multiple Availabilities";
    } else {
      return "Delete Multiple Availabilities";
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
      <Button
        variant="outlined"
        color="inherit"
        startIcon={<img src={BinIcon} width={20} height={20} />}
        onClick={onDeleteClick}
        disabled={selectedCount === 0 || isBulkDeleting}
        sx={{
          borderRadius: 2,
          textTransform: 'none',
          fontWeight: 600,
          px: 3,
          opacity: selectedCount === 0 ? 0.6 : 1,
          borderColor: 'transparent',
          "&:hover": {
            borderColor: 'transparent',
            backgroundColor: 'transparent'
          },
          "&:disabled": {
            borderColor: 'transparent',
            backgroundColor: 'transparent'
          }
        }}
      >
        {isBulkDeleting ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          getButtonText()
        )}
      </Button>
    </Box>
  );
};

export default BulkDeleteButton;
